export const WELCOME_TO_MEMRISE_STORAGE_KEY = 'NEW_USER_WELCOME_TO_MEMRISE';
export const EXPLAIN_LEVEL_SELECTION_IMPACT = 'EXPLAIN_LEVEL_SELECTION_IMPACT';
export const MIGRATED_TO_MY_PROGRESS_STORAGE_KEY = 'MIGRATED_TO_MY_PROGRESS';
export const CLASSIC_MIGRATION_ONBOARDING_STORAGE_KEY = 'CLASSIC_MIGRATION_ONBOARDING';
export const MY_WORDS_INTRO_STORAGE_KEY = 'MY_WORDS_INTRO';
export const SHOULD_DISPLAY_MY_ACTIVITIES_INTRO_STORAGE_KEY = 'MY_ACTIVITIES_INTRO';
export const PRE_RELEASE_USERS_SEEN_MY_ACTIVITIES_STORAGE_KEY = 'NEW_FEATURE_MY_ACTIVITIES';
export const SEEN_WORDLISTS_TOAST_STORAGE_KEY = 'SEEN_WORDLISTS_TOAST';
export const FEEDBACK_CARD_HOME_SCREEN_STORAGE_KEY = 'FEEDBACK_CARD_HOME_SCREEN';
export const STAGE_UP_POINTS_STORAGE_KEY = 'STAGE_UP_POINTS';
export const HAS_SEEN_2025_ONBOARDING_STORAGE_KEY = 'HAS_SEEN_2025_ONBOARDING';
export const HAS_SEEN_SOFT_SELL_STORAGE_KEY = 'HAS_SEEN_SOFT_SELL';
export const AUTO_SUBSCRIBE_AFTER_RELOAD_STORAGE_KEY = 'AUTO_SUBSCRIBE_AFTER_RELOAD';
export const MY_LESSONS_INTRO_MODAL_STORAGE_KEY = 'MY_LESSONS_INTRO_MODAL';
export const SHOW_REPETITION_INTRO_MODAL_STORAGE_KEY = 'SHOW_REPETITION_INTRO_MODAL';

export const DEV_TOOL_ENABLE_DEBUG_PANEL_STORAGE_KEY = 'DEV_TOOL_ENABLE_DEBUG_PANEL';
export const DEV_TOOL_PRONUNCIATION_BUDDY_LEARNABLE_STORAGE_KEY =
  'DEV_TOOL_PRONUNCIATION_BUDDY_LEARNABLE';
